import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-grid-fill text-white text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-foreground-900">Vigorbuy Spreadsheet Hub</span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                The most complete Vigorbuy Spreadsheet resource platform helping users discover products, compare categories, understand safety, and make smarter buying decisions.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Home</Link>
                <Link to="/blog/vigorbuy-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Complete Guide</Link>
                <Link to="/blog/vigorbuy-spreadsheet-beginner-tutorial" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Beginner Tutorial</Link>
                <Link to="/blog/vigorbuy-spreadsheet-how-to-use" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Shopping Guide</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/blog/vigorbuy-spreadsheet-safety-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Safety Guide</Link>
                <Link to="/blog/vigorbuy-spreadsheet-category-comparison" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Category Comparison</Link>
                <Link to="/#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Categories</Link>
                <Link to="/#safety" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Safety Information</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">External Resources</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  Vigorbuy Spreadsheet <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  Shoes Category <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  Hoodies/Sweaters <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  T-Shirts <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet Hub. All rights reserved. Vigorbuyspread.bond is an independent informational resource.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Privacy</Link>
              <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}